import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import type { ImmutableRootState, Langcodes } from '@uncinc/react-drupal-core/types';

import { DEFAULT_LANGUAGE, SEARCH_PATH } from '../../../../config/constants';
import ButtonWrapper from '../../../ButtonWrapper';

const MetaSearchEmptyState: React.FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'searchkit.meta_search' });

  const language = useSelector<ImmutableRootState<Langcodes>, Langcodes>(
    (state) => state.getIn(['uiInternal', 'language'], DEFAULT_LANGUAGE),
  );

  const classes = c('MetaSearch__EmptyState', 'Paper');

  return (
    <div className={classes}>
      <h3 className="asH4">
        {t('result_empty_title')}
      </h3>

      <p className="body--small">
        {t('result_empty_body')}
      </p>

      <ButtonWrapper type="secondary" href={(SEARCH_PATH as Record<string, string>)[language] ?? SEARCH_PATH.en}>
        {t('result_empty_button')}
      </ButtonWrapper>
    </div>
  );
};

export default MetaSearchEmptyState;
